import {FormControl} from '@angular/forms';
import {IDropdownObject} from './dropdown-object.interface';

export interface IShortWorkingPeriod {
  employeeId?: number;
  startDate: string;
  status: IDropdownObject;
  employmentForm: IDropdownObject;
  id: number;
  isCancelled?: boolean;
}

export interface IWorkingPeriod {
  employeeId?: number;
  newStatus: IDropdownObject;
  lastWorkingDay: string;
  startDate: null | string;
  terminationReason: IDropdownObject;
  accountBlockOption: IDropdownObject;
  equipmentOption: IDropdownObject;
  isVoluntary: null | string;
  isCancelled?: boolean;
}

export interface INewWorkingPeriod extends IWorkingPeriod {
  comment: string;
  createdBy: IDropdownObject;
  location: string;
  accountBlockDate: null | string;
  rate: number | null;
  stavka: number | null;
}

export interface WorkingPeriodFormGroup {
  employeeId: FormControl<number | null>;
  lastWorkingDay?: FormControl<string | null>;
  newStatus: FormControl<IDropdownObject | null>;
  createdBy: FormControl<IDropdownObject | null>;
  terminationReason?: FormControl<IDropdownObject | null>;
  corporateAccount: FormControl<IDropdownObject | null>;
  equipment: FormControl<IDropdownObject | null>;
  location: FormControl<string | null>;
  accountBlockDate?: FormControl<string | null>;
  comment: FormControl<string | null>;
  rate?: FormControl<number | null>;
  stavka?: FormControl<number | null>;
  startDate?: FormControl<string | null>;
}

export interface IIncreasePeriodDropdowns {
  corporateAccountOptionsList: IDropdownObject[];
  equipmentOptionsList: IDropdownObject[];
  pmOptionsList: IDropdownObject[];
  lmOptionsList: IDropdownObject[];
}

export interface IDecreasePeriodDropdowns {
  corporateAccountOptionsList: IDropdownObject[];
  equipmentOptionsList: IDropdownObject[];
  terminationReasonOptionsList: IDropdownObject[];
  accountCorrespondenceOptionsList: IDropdownObject[];
}

export enum WorkingPeriodTimeStatus {
  Cancelled = 'Cancelled',
  Pending = 'Pending',
  Conducted = 'Conducted',
}

export enum workingPeriodStatus {
  Employee = 'Employee',
  Former = 'Former',
  ContractorPT = 'Contractor part-time',
  ContractorFT = 'Contractor full-time',
  Consultant = 'Consultant',
}

export enum workingPeriodStatuses {
  Former = 0,
  ContractorPT = 1,
  Consultant = 1,
  Employee = 2,
}
